const ONBOARDING_KEY = 'onboarding_completed';
const FIRST_CASE_KEY = 'first_case_completed';

export function isFirstTimeUser(): boolean {
  return !localStorage.getItem(ONBOARDING_KEY);
}

export function isOnboardingCompleted(): boolean {
  return localStorage.getItem(ONBOARDING_KEY) === 'true';
}

export function markOnboardingComplete(): void {
  localStorage.setItem(ONBOARDING_KEY, 'true');
}

export function isFirstCaseCompleted(): boolean {
  return localStorage.getItem(FIRST_CASE_KEY) === 'true';
}

export function markFirstCaseCompleted(): void {
  localStorage.setItem(FIRST_CASE_KEY, 'true');
} 